import React from 'react';
import PropTypes from 'prop-types';

import CoverSplit from './CoverSplit';

function CoverAction({ alt, src, size, className, onClick, tag = null, style }) {
  return (
    <div onClick={onClick} style={style}>
      <CoverSplit name={alt} images={[src]} size={size} className={className} tag={tag} />
    </div>
  )
}

CoverAction.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  size: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
  tag: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default CoverAction;
